export let EarconName = /*#__PURE__*/function (EarconName) {
  EarconName["Drag"] = "drag";
  EarconName["Drop"] = "drop";
  EarconName["DrillDown"] = "drillDown";
  EarconName["DrillUp"] = "drillUp";
  EarconName["Error"] = "error";
  EarconName["InputFull"] = "inputFull";
  EarconName["Notification"] = "notification";
  EarconName["PopupClose"] = "popupClose";
  EarconName["PopupOpen"] = "popupOpen";
  EarconName["ProcessComplete"] = "processComplete";
  return EarconName;
}({});
//# sourceMappingURL=types.js.map